const AllRequestsSidebarIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    id="request-refund-16px"
    width="24"
    fill="#B0B1B4"
    viewBox="0 0 16 16"
    {...props}
  >
    <g
      id="SVGRepo_tracerCarrier"
      stroke="#CCC"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="0.352"
    >
      <path
        id="Path_45"
        d="M-16 11a2 2 0 0 0 2-2 2 2 0 0 0-2-2 2 2 0 0 0-2 2 2 2 0 0 0 2 2m0-3a1 1 0 0 1 1 1 1 1 0 0 1-1 1 1 1 0 0 1-1-1 1 1 0 0 1 1-1m2.5 4h-5a2.5 2.5 0 0 0-2.5 2.5 1.5 1.5 0 0 0 1.5 1.5h7a1.5 1.5 0 0 0 1.5-1.5 2.5 2.5 0 0 0-2.5-2.5m1 3h-7a.5.5 0 0 1-.5-.5 1.5 1.5 0 0 1 1.5-1.5h5a1.5 1.5 0 0 1 1.5 1.5.5.5 0 0 1-.5.5m5-15h-7A2.5 2.5 0 0 0-17 2.5v3a.5.5 0 0 0 .5.5.5.5 0 0 0 .5-.5v-3A1.5 1.5 0 0 1-14.5 1h3v1A1.5 1.5 0 0 0-13 3.5 1.5 1.5 0 0 0-11.5 5v1h-1a.5.5 0 0 0-.5.5.5.5 0 0 0 .5.5h1v.5a.5.5 0 0 0 .5.5.5.5 0 0 0 .5-.5V7A1.5 1.5 0 0 0-9 5.5 1.5 1.5 0 0 0-10.5 4V3h1a.5.5 0 0 0 .5-.5.5.5 0 0 0-.5-.5h-1V1h3A1.5 1.5 0 0 1-6 2.5v5A1.5 1.5 0 0 1-7.5 9h-3a.5.5 0 0 0-.354.146L-12 10.293V9.5a.5.5 0 0 0-.5-.5.5.5 0 0 0-.5.5v2a.5.5 0 0 0 .309.462.5.5 0 0 0 .191.038.5.5 0 0 0 .354-.146L-10.293 10H-7.5A2.5 2.5 0 0 0-5 7.5v-5A2.5 2.5 0 0 0-7.5 0M-10 5.5a.5.5 0 0 1-.5.5V5a.5.5 0 0 1 .5.5M-11.5 4a.5.5 0 0 1-.5-.5.5.5 0 0 1 .5-.5Z"
        data-name="Path 45"
        transform="translate(21)"
      ></path>
    </g>
    <g id="SVGRepo_iconCarrier">
      <path
        id="Path_45"
        d="M-16 11a2 2 0 0 0 2-2 2 2 0 0 0-2-2 2 2 0 0 0-2 2 2 2 0 0 0 2 2m0-3a1 1 0 0 1 1 1 1 1 0 0 1-1 1 1 1 0 0 1-1-1 1 1 0 0 1 1-1m2.5 4h-5a2.5 2.5 0 0 0-2.5 2.5 1.5 1.5 0 0 0 1.5 1.5h7a1.5 1.5 0 0 0 1.5-1.5 2.5 2.5 0 0 0-2.5-2.5m1 3h-7a.5.5 0 0 1-.5-.5 1.5 1.5 0 0 1 1.5-1.5h5a1.5 1.5 0 0 1 1.5 1.5.5.5 0 0 1-.5.5m5-15h-7A2.5 2.5 0 0 0-17 2.5v3a.5.5 0 0 0 .5.5.5.5 0 0 0 .5-.5v-3A1.5 1.5 0 0 1-14.5 1h3v1A1.5 1.5 0 0 0-13 3.5 1.5 1.5 0 0 0-11.5 5v1h-1a.5.5 0 0 0-.5.5.5.5 0 0 0 .5.5h1v.5a.5.5 0 0 0 .5.5.5.5 0 0 0 .5-.5V7A1.5 1.5 0 0 0-9 5.5 1.5 1.5 0 0 0-10.5 4V3h1a.5.5 0 0 0 .5-.5.5.5 0 0 0-.5-.5h-1V1h3A1.5 1.5 0 0 1-6 2.5v5A1.5 1.5 0 0 1-7.5 9h-3a.5.5 0 0 0-.354.146L-12 10.293V9.5a.5.5 0 0 0-.5-.5.5.5 0 0 0-.5.5v2a.5.5 0 0 0 .309.462.5.5 0 0 0 .191.038.5.5 0 0 0 .354-.146L-10.293 10H-7.5A2.5 2.5 0 0 0-5 7.5v-5A2.5 2.5 0 0 0-7.5 0M-10 5.5a.5.5 0 0 1-.5.5V5a.5.5 0 0 1 .5.5M-11.5 4a.5.5 0 0 1-.5-.5.5.5 0 0 1 .5-.5Z"
        data-name="Path 45"
        transform="translate(21)"
      ></path>
    </g>
  </svg>
);

export default AllRequestsSidebarIcon;
